export const getFileDirectory = (filePath: string) => {
  const asArray = filePath.split('/');
  asArray.pop();
  return asArray.join('/');
};
